import { useState } from 'react'
import styles from './CopyLink.module.scss'
import LinkIcon from '../Icons/LinkIcon'

export interface ICopyLink {
  title: string;
  link: string;
}

export default function CopyLink({ title, link }: ICopyLink) {
  const defaultButtonText = 'Copy'
  const clickedButtonText = 'Copied!'
  const buttonTimeout = 5000

  const [buttonText, setButtonText] = useState(defaultButtonText)

  async function copyTextToClipboard(): Promise<void> {
    setButtonText(clickedButtonText)
    await navigator.clipboard.writeText(link)
    setTimeout(() => {
      setButtonText(defaultButtonText)
    }, buttonTimeout)
  }

  return (
    <div className={styles.copyBox}>
      {title != null && <h5 className={styles.title}>{title}</h5>}
      <div className={styles.content}>
        <div className={styles.linkArea}>
            <a href={link}
                className={styles.link}
                target="_blank"
                aria-label="Open this link in a new tab" rel="noreferrer">
              {link}
            </a>
        </div>
        <button aria-label="Copy link to clipboard"
                className={styles.copyButton}
                onClick={() => {
                  void copyTextToClipboard()
                }}>
          {buttonText === defaultButtonText && <LinkIcon />}
          {buttonText}
        </button>
      </div>
    </div>
  )
}
